/**
 *  weiboTimingSignModule
 *
 * Description 微博渠道-定时签发
 * author: Qian.qianchen 2018-11-21
 */
'use strict';
angular.module('weiboTimingSignedModule', ['weiboTimingSignedRouterModule']).controller('weiboTimingSignedCtrl', [
    '$scope',
    '$state',
    'modalDialog',
    'editingCenterWeiBoService',
    'editcenterRightsService',
    '$q',
    'trsHttpService',
    'weiboConst',
    'editingMediatype',
    'editingCenterService',
    function ($scope, $state, modalDialog, editingCenterWeiBoService, editcenterRightsService, $q, trsHttpService, weiboConst, editingMediatype, editingCenterService) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                items: [],
                statusItems: [],
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 15,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.status = {
                channelId: $state.params.wbchannelid,
                isOnlyMine: false,
                isESSearch: false,
                copyCurrPage: 1,
                keywords: '',
                isSearch: false, // ES搜索标志
                hasRight: true,
            };
            $scope.params = {
                serviceid: 'wcm61_scmmicrocontent',
                methodname: 'queryTimingPubDoc',
                // "methodname": "queryOfDingShiNewToJson",
                PageIndex: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
                AccountId: $state.params.wbchannelid,
                FlowStatus: '30',
                CONTENT: '',
                StartTime: '',
                EndTime: '',
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            initDropdown();
            initBtnRights();
            // requestData().then(function (data) {
            //     getTimeStatus(data);
            // });
        }

        // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
        $scope.requestData = function() {
            requestData().then(function (data) {
                getTimeStatus(data);
            });
        };

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initDropdown() {
            $scope.data.docTypeJsons = weiboConst.docTypeJsons;
            $scope.data.selectedDocType = weiboConst.docTypeJsons[0];
            // editingCenterService.dealStorage($scope);
        }

        /**
         * [initBtnRights description] 初始化权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            editcenterRightsService.initWeiboListBtn('microblog.dingshiqianfa', $scope.status.channelId).then(function (rights) {
                $scope.status.btnRights = rights;
            });
        }

        /**
         * [requestData description] 数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            var deferred = $q.defer();
            var params = $scope.status.isSearch ? getESSearchParams() : $scope.params;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', true).then(
                function (data) {
                    if (!$scope.status.isSearch) {
                        $scope.status.keywords = '';
                    }
                    $scope.status.hasRight = true;
                    $scope.data.items = data.DATA;
                    !!data.PAGER ? ($scope.page = data.PAGER) : ($scope.page.ITEMCOUNT = '0');
                    deferred.resolve(data);
                },
                function (data) {
                    $scope.status.hasRight = false;
                }
            );
            return deferred.promise;
        }

        /**
         * [getESSearchParams description] 处理ES参数
         *
         * @return  {[type]}  [return description]
         */
        function getESSearchParams() {
            const esparams = {
                serviceid: 'mlf_hybasesearch',
                methodname: 'queryForNewMediaDoc',
                mediaType: editingMediatype.weibo,
                searchParams: {
                    PAGESIZE: $scope.page.PAGESIZE,
                    PAGEINDEX: $scope.page.CURRPAGE,
                    CHANNELID: $state.params.chinnelid,
                    status_model: '3', //
                    searchFields: [
                        {
                            searchField: '',
                            keywords: $scope.status.keywords,
                        },
                        {
                            searchField: 'docType',
                            keywords: $scope.data.selectedDocType.value || '',
                        },
                        {
                            searchField: 'timeType',
                            keywords:
                                angular.isDefined($scope.status.fromdate) && $scope.status.fromdate !== ''
                                    ? $scope.status.fromdate + ',' + $scope.status.untildate
                                    : '',
                        },
                        {
                            searchField: '_sort',
                            keywords: 'time',
                        },
                        {
                            searchField: 'isTiming',
                            keywords: '1'
                        }
                    ],
                }
            };
            esparams.searchParams = JSON.stringify(esparams.searchParams);
            return esparams;
        }   

        /**
         * [queryByDropdown description] 下拉框回调函数
         *
         * @param   {[type]}  type   [type description]
         * @param   {[type]}  value  [value description]
         *
         * @return  {[type]}         [return description]
         */
        $scope.queryByDropdown = function(type, value) {
            $scope.page.CURRPAGE = 1;
            $scope.params[type] = value;
            requestData();
        };

        /**
         * [getTimeStatus description] 获取时间状态
         * @param   {[type]}  data  [data description]
         * @return  {[type]}        [return description]
         */
        function getTimeStatus(data) {
            var deferred = $q.defer();
            data = angular.isDefined(data.PAGER) ? data.DATA : data;
            if (!data.length) {
                deferred.resolve();
                return;
            }
            var objectIds = data
                .map(function (currVal) {
                    return currVal.METADATAID;
                })
                .join(',');
            var params = {
                serviceid: 'wcm61_scmmicrocontent',
                methodname: 'queryForDingShiDataToJson',
                ObjectIds: objectIds,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                for (var i = 0; i < data.length; i++) {
                    for (var j = 0; j < $scope.data.items.length; j++) {
                        if (data[i].SCMMCID == $scope.data.items[j].METADATAID) {
                            $scope.data.items[j].SCMMCPUBLISHTASKID = data[i].SCMMCPUBLISHTASKID;
                            $scope.data.items[j].TASKUSER = data[i].CRUSER;
                            $scope.data.items[j].TASKTIME = data[i].SCHEDULETIME;
                            $scope.data.items[j].TASKSTATUS = data[i].PUBLISHSTATUSSTR;
                            $scope.data.items[j].TASKUSERTRUENAME = data[i].TASKUSERTRUENAME;
                        }
                    }
                }
                deferred.resolve(data);
            });
            return deferred.promise;
        }

        /**
         * [timeFormat description] 日期day+1处理
         * @param  {[String]} timeStr [description]日期字符串
         * @return {[type]}         [description]
         */
        function timeFormat(timeStr) {
            if (angular.isDefined(timeStr) && timeStr != '') {
                var date = timeStr.replace(/-/g, '/');
                var timestamp = new Date(date).getTime();
                timestamp = timestamp + 24 * 60 * 60 * 1000;
                var d = new Date(timestamp);
                return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
            } else {
                return '';
            }
        }

        /**
         * [fullTextSearch description] 关键字搜索
         * @param  {[type]} ev [description] event对象
         * @return {[type]}    [description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.page.CURRPAGE = 1;
                $scope.status.isSearch = true;
                requestData();
            }
        };

        /**
         * [pageChanged description] 换页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function () {
            $scope.params.PageIndex = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData().then(function (data) {
                getTimeStatus(data);
            });
        };

        /**
         * [timeSelect description] 时间筛选
         * @return {[type]} [description]
         */
        $scope.timeSelect = function () {
            // $scope.params.StartTime = $scope.status.fromdate;
            // $scope.params.EndTime = timeFormat($scope.status.untildate);
            $scope.params.OperTimeStart = $scope.status.fromdate;
            // $scope.params.OperTimeEnd = timeFormat($scope.status.untildate);
            $scope.params.OperTimeEnd = $scope.status.untildate;
            requestData().then(function (data) {
                getTimeStatus(data);
            });
        };

        /**
         * [changeSignedTIme description] 修改定时签发时间
         * @param  {[object]} item [description] 需要修改签发时间的微博对象
         * @return {[type]}      [description]
         */
        $scope.changeSignedTime = function (item) {
            editingCenterWeiBoService.timeSignWeibo([item], false, '30', function (result) {
                if (result == 'success') {
                    $scope.status.isSearch = false;
                    modalDialog.alertType('签发时间修改成功', '', 'success', false);
                    requestData().then(function (data) {
                        getTimeStatus(data);
                    });
                } else {
                    modalDialog.alertType('该微博定时签发失败！', result.result.detail, 'error', false);
                }
            });
        };

        /**
         * [revoke description] 撤销
         * @param  {[object]} item [description] 微博对象
         * @return {[type]}      [description]
         */
        $scope.revoke = function (item) {
            modalDialog.confirmModal('', '是否确认撤销此次定时签发', function () {
                var params = {
                    serviceid: 'wcm61_scmpublishtask',
                    methodname: 'cancelSCMMCPublishTaskToJson',
                    PublishTaskId: item.METADATAID,
                };
                $scope.status.isSearch = false;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    modalDialog.alertType('撤销成功', '', 'success', false);
                    requestData().then(function (data) {
                        getTimeStatus(data);
                    });
                });
            });
        };
    },
]);
